const TreeIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'>
    <path d='M16 64v64H40 56 80V64H16zm24 80H16 0V128 64 48H16 80 96V64v64 16H80 56V256h72V224 208h16 64 16v16 64 16H208 144 128V288 272H56V416h72V384 368h16 64 16v16 64 16H208 144 128V448 432H48 40v-8V264 144zM144 416v16 16h64V384H144v32zm0-128h64V224H144v32 16 16zM168 88h8H496h8v16h-8H176h-8V88zM296 248h8H496h8v16h-8H304h-8V248zm0 160h8H496h8v16h-8H304h-8V408z' />
  </svg>
)

export { TreeIcon }
